// infrastructure/supabase/repositories/cajaSesion.repository.js
import { supabase } from "../../../infra_/supabase/supabaseClient.js";
import { ahora } from "../../../../utils/fechas.js";

export async function abrirSesionCaja({
  id_usuario_apertura,
  saldo_inicial,
  punto,
  fecha_apertura,
  observaciones = null,
}) {
  const { data, error } = await supabase
    .from("caja_sesion")
    .insert([
      {
        fecha_apertura,
        id_usuario_apertura,
        saldo_inicial,
        estado: "abierta",
        observaciones,
        punto,
        created_at: ahora(),
      },
    ])
    .select()
    .single();

  if (error) {
    console.error("[CajaSesionRepository] Error al abrir sesión:", error);
    throw error;
  }

  return data;
}

// cerrar sesión de caja

export async function cerrarSesionCaja({
  id_sesion,
  id_usuario_cierre,
  saldo_final,
  fecha_cierre,
  observaciones = null,
}) {
  const { data, error } = await supabase
    .from("caja_sesion")
    .update({
      fecha_cierre: ahora(),
      id_usuario_cierre,
      saldo_final,
      estado: "cerrada",
      observaciones,
      updated_at: ahora(),
    })
    .eq("id_sesion", id_sesion)
   
    .select()
    .single();

  if (error) {
    console.error("[CajaSesionRepository] Error al cerrar sesión:", error);
    throw error;
  }
  if (!data) {
    throw new Error(
      "No se pudo cerrar la sesión (no existe o ya estaba cerrada)",
    );
  }

  return data;
}



// infrastructure/supabase/repositories/cajaSesion.repository.js
export async function listarSesionesCaja({ punto, estado, desde, hasta }) {
  let query = supabase.from("caja_sesion").select("*");

  if (punto) query = query.eq("punto", punto);
  if (estado) query = query.eq("estado", estado);
  if (desde) query = query.gte("fecha_apertura", desde);
  if (hasta) query = query.lte("fecha_apertura", hasta);

  const { data, error } = await query.order("fecha_apertura", {
    ascending: false,
  });

  if (error) throw error;
  return data ?? [];
}

// application/useCases/obtenerSesionAbierta.usecase.js

export async function obtenerSesionAbiertaPorPuntoYFecha(punto, fecha) {
  // punto es número, fecha tipo 'YYYY-MM-DD' (DATE en DB)
  const { data, error } = await supabase
    .from("caja_sesion")
    .select("*")
    .eq("punto", punto)

    
    .eq("fecha_apertura", fecha)
    .maybeSingle();

  if (error) {
    console.error("[CajaSesionRepository] Error al obtener sesión:", error);
    throw error;
  }

  return data; // devuelve sesión del día o null
}



// infrastructure/supabase/repositories/cajaSesion.repository.js
export async function obtenerSesionAbiertaPorPunto(punto) {
  const { data, error } = await supabase
    .from("caja_sesion")
    .select("*")
    .eq("punto", punto)
    .eq("estado", "abierta")
    .maybeSingle(); // puede devolver null

  if (error) {
    console.error(
      "[CajaSesionRepository] Error al obtener sesión abierta:",
      error,
    );
    throw error;
  }

  return data; // sesión o null
}